// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RestOutlinedSvg from "@ant-design/icons-svg/es/asn/RestOutlined";
import AntdIcon from '../components/AntdIcon';

var RestOutlined = function RestOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RestOutlinedSvg
  }));
};

RestOutlined.displayName = 'RestOutlined';
export default React.forwardRef(RestOutlined);